import isPaymentScheduleEnabled from 'checkout/selectors/payment/paymentSchedule/isPaymentScheduleEnabled'
import FormatCurrency from 'components/Common/FormatCurrency'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextLink from 'LuxKit/TextLink'
import FormatPercent from 'components/utils/Formatters/FormatPercent'
import ModalContext from 'contexts/ModalContext'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import React, { useCallback, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import TourDepositInfoModal from './TourDepositInfoModal'

interface Props {
  offer: App.Tours.TourV2Offer
}

function TourDepositBanner({ offer }: Props) {
  const deposit = offer.paymentScheduleTemplate?.schedules[0]

  const showModal = useContext(ModalContext)
  const openDepositInfoModal = useCallback(async() => {
    if (offer.paymentScheduleTemplate) {
      showModal(<TourDepositInfoModal paymentScheduleTemplate={offer.paymentScheduleTemplate} />)
    }
  }, [offer.paymentScheduleTemplate, showModal])

  if (!deposit) return null

  const depositAmount = <>
    {deposit.amountType === 'percentage' && <FormatPercent value={deposit.amountValue} />}
    {deposit.amountType === 'fixed_amount' && <FormatCurrency value={deposit.amountValue} />}
  </>

  return <MessageBanner kind="promotional-primary">
    <FormattedMessage
      id="BA6TOK2xW7"
      defaultMessage="<b>Deposits available</b>: Book now from just {depositAmount}. <link>Find out more</link>"
      description="Tour deposit banner showing deposit amount with link to learn more"
      values={{
        b: (chunks) => <b>{chunks}</b>,
        depositAmount,
        link: (chunks) => <TextLink onClick={openDepositInfoModal}>{chunks}</TextLink>,
      }}
    />
  </MessageBanner>
}

export default withMountGuard(() => {
  return useAppSelector(isPaymentScheduleEnabled)
})(TourDepositBanner)
